import {IComponent} from '@assets/js/@types/Component';

interface IntroComponent extends IComponent {
  getLocalStorageItem(name: string): string | null;
  setLocalStorageItem(name: string, value: string): void;
  onVideoEnded(): void;
}

const intro: IntroComponent = {
  cfg: {
    name: 'c-intro',
    selectors: {
      intro: '.js-intro',
      video: '#intro-video',
      videoMobile: '#intro-video-mobile',
    },
    classes: {
      hidden: 'hidden',
      opacity0: 'opacity-0',
      transition: 'transition-opacity',
      duration: 'duration-700',
    },
    el: {
      $intro: null,
    },
    els: {
      $video: null,
      $videoMobile: null,
    },
  },

  setElements(mainEl: HTMLElement) {
    this.cfg.el.$intro = mainEl;
    this.cfg.els.$video = mainEl.querySelector(this.cfg.selectors.video);
    this.cfg.els.$videoMobile = mainEl.querySelector(this.cfg.selectors.videoMobile);
    this.cfg.els.$cookieBanner = mainEl.querySelector(this.cfg.selectors.cookieBanner);
  },

  init(el: HTMLElement) {
    this.setElements?.(el);

    const introSeen = this.getLocalStorageItem('intro_seen');

    if (introSeen) {
      this.cfg.el.$intro.classList.add(this.cfg.classes.hidden);
    } else {
      this.cfg.el.$intro.classList.remove(this.cfg.classes.opacity0);
      this.cfg.els.$video.addEventListener('ended', this.onVideoEnded.bind(this), false);
      this.cfg.els.$videoMobile.addEventListener('ended', this.onVideoEnded.bind(this), false);
    }
  },

  getLocalStorageItem(name: string) {
    return localStorage.getItem(name);
  },

  setLocalStorageItem(name: string, value: string) {
    localStorage.setItem(name, value);
  },

  onVideoEnded() {
    this.cfg.el.$intro.classList.add(this.cfg.classes.transition);
    this.cfg.el.$intro.classList.add(this.cfg.classes.duration);

    // fade out
    this.cfg.el.$intro.classList.add(this.cfg.classes.opacity0);

    // hide
    setTimeout(() => {
      this.cfg.el.$intro.classList.add(this.cfg.classes.hidden);
    }, 1000);

    this.setLocalStorageItem('intro_seen', 'true');
  },
};

export default intro;
